import { Reveal } from "@/lib/motion";
import { Landmark, Building2, Globe2, Coins, TrendingUp, Sparkles } from "lucide-react";
import { useSiteContent } from "@/lib/useSiteContent";

const ICONS = [Landmark, Building2, Globe2, Coins, TrendingUp, Sparkles];

export default function WhyDubai() {
  const c = useSiteContent().why_dubai;
  return (
    <section id="why-dubai" data-testid="why-dubai-section" className="section-pad bg-white">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="md:max-w-3xl">
          <Reveal><p className="eyebrow">{c.eyebrow}</p></Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-serif-luxe text-[#1D1D1F] text-4xl md:text-5xl leading-[1.08] mt-5">
              {c.heading}
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="text-[#616161] leading-relaxed mt-6 max-w-2xl">{c.intro}</p>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 mt-16">
          {(c.cards || []).map((it, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <Reveal key={i} delay={i * 0.05}>
                <div data-testid={`why-dubai-card-${i}`} className="card-luxe h-full flex flex-col">
                  <Icon size={28} strokeWidth={1.2} className="text-[#B68D40] mb-6" />
                  <h3 className="font-serif-luxe text-2xl text-[#1D1D1F] mb-4">{it.title}</h3>
                  <p className="text-[#616161] text-sm leading-relaxed">{it.body}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
